var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.renderless
    ? _c("div", { staticClass: "profile-labs" }, [
        _c("div", { staticClass: "row" }, [
          _vm.userLabs.length
            ? _c("div", { staticClass: "col-12" }, [_vm._m(0)])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              !_vm.userLabs.length
                ? [_c("no-lab-banner")]
                : [
                    _c(
                      "div",
                      { staticClass: "row profile-labs__list" },
                      _vm._l(_vm.userLabs, function(lab) {
                        return _c(
                          "div",
                          { key: lab.ID, staticClass: "col-sm-6" },
                          [
                            _c("lab-card", {
                              attrs: {
                                lab: lab,
                                equipments: _vm.getEquipments(
                                  lab.UF_COOKING_TYPE.ID
                                ),
                                "for-who": _vm.getForWho(lab.UF_FOR.ID)
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "edit-button",
                                    fn: function() {
                                      return [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "lab-card__edit",
                                            attrs: {
                                              href:
                                                "/personal/lab/" + lab.ID + "/"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "d-none d-sm-block"
                                              },
                                              [_vm._v("Редактировать")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "svg",
                                              {
                                                staticClass: "d-block d-sm-none"
                                              },
                                              [
                                                _c("use", {
                                                  attrs: {
                                                    "xlink:href":
                                                      "/sprite.svg#icon-edit"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ],
              _vm._v(" "),
              !_vm.isCatalog
                ? _c(
                    "div",
                    { staticClass: "profile-labs__labs-text" },
                    [_vm._t("default")],
                    2
                  )
                : _vm._e()
            ],
            2
          )
        ])
      ])
    : _c(
        "div",
        [
          _vm._t("default", null, null, {
            labPlaceTypes: _vm.labPlaceTypes,
            labCookingTypes: _vm.labCookingTypes,
            userLabs: _vm.userLabs,
            getForWho: _vm.getForWho,
            getEquipments: _vm.getEquipments
          })
        ],
        2
      )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "profile-labs__create" }, [
      _c("a", { attrs: { href: "/personal/lab/" } }, [
        _vm._v("+ Создать лабораторию")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }